module.exports = __webpack_public_path__ + "img/draco_disarming_dumbledore.0b20e922.jpg";